import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ---------- Public endpoints ----------
export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter/subscribe", { email });
  return data;
}

export async function submitContact(payload) {
  const { data } = await api.post("/contact", payload);
  return data;
}

// ---------- Admin token storage ----------
//
// SECURITY NOTE: The admin JWT is kept in sessionStorage rather than
// localStorage. sessionStorage is scoped to the tab and is cleared when the
// tab closes, which limits the persistence window for any XSS-stolen token
// and prevents cross-tab token sharing. For higher-assurance deployments,
// move to an httpOnly, Secure, SameSite=Strict cookie issued by the backend
// (this requires enabling CORS credentials and adding CSRF protection on
// admin POST/DELETE routes).
const TOKEN_KEY = "nn_admin_token";

export function getToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch (e) {
    return null;
  }
}

export function setToken(t) {
  if (!t) return;
  try {
    sessionStorage.setItem(TOKEN_KEY, t);
  } catch (e) {
    /* storage disabled (private mode etc) — ignore */
  }
}

export function clearToken() {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    /* ignore */
  }
}

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

// ---------- Admin endpoints ----------
export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  setToken(data.token);
  return data;
}

export async function adminVerify() {
  const { data } = await api.get("/admin/verify", { headers: authHeaders() });
  return data;
}

export async function adminListNewsletter() {
  const { data } = await api.get("/admin/newsletter", { headers: authHeaders() });
  return data;
}

export async function adminDeleteNewsletter(id) {
  const { data } = await api.delete(`/admin/newsletter/${id}`, { headers: authHeaders() });
  return data;
}

export async function adminListMessages() {
  const { data } = await api.get("/admin/messages", { headers: authHeaders() });
  return data;
}

export async function adminDeleteMessage(id) {
  const { data } = await api.delete(`/admin/messages/${id}`, { headers: authHeaders() });
  return data;
}
